import React, {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {Navigate} from "react-router-dom";
import {useApplicationConfig} from "../application-configuration/core/ApplicationConfiguration";
import {DynamicFormLoader} from "./DynamicFormLoader";
import {DynamicFormProvider} from "./core/DynamicForm";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from "@mui/x-date-pickers";
import axios from "../../helpers/axios";
import {LoadingIndicator} from "../common/components/LoadingIndicator";
import {WithChildren} from "../../../_metronic/helpers";
import {RequestError} from "../common/components/RequestError";
import {DynamicComponentsStateProvider} from "./core/DynamicComponentsState";
import { Http } from "../../helpers/http";

const MainLayout = ({children}: WithChildren) => {
    return (
        <div className='card mb-5 mb-xl-10' id='kt_page'>
            <div className='card-body p-9'>
                {children}
            </div>
        </div>
    )
}

export function DynamicPage() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [initialFormData, setInitialFormData] = useState<any | null>(null)

    const location = useLocation();

    const {menuFlat} = useApplicationConfig()
    const pathSegments = location.pathname.split('/');
    const activeUrl = pathSegments.pop();
    const menuId = activeUrl?.split('-').shift();

    const id = menuId ? parseInt(menuId) : 0
    const activeMenu = menuFlat?.filter(item => item.id === id).shift()

    const locationUpdated = async () => {
        if (!menuId) {
            return;
        }

        setError(false)
        setLoading(true)
        try {
            const {data: formData} = await Http.post('get_form_data', {
                'menu_id': menuId,
            })
            setInitialFormData(formData)
        } catch (e) {
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        locationUpdated()
    }, [location])

    if (!menuId) {
        return <Navigate to='/error/404'/>;
    }

    if (error) {
        return (
            <MainLayout>
                <RequestError onRefresh={locationUpdated}/>
            </MainLayout>
        )
    }

    if (loading) {
        return (
            <MainLayout>
                <div className='d-flex align-content-center'>
                    <LoadingIndicator/> <span className='ps-5 pt-1'>Loading Page...</span>
                </div>
            </MainLayout>
        )
    }

    return (
        <MainLayout>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DynamicComponentsStateProvider>
                    <DynamicFormProvider currentMenu={activeMenu!} initialFormData={initialFormData}>
                        <DynamicFormLoader/>
                    </DynamicFormProvider>
                </DynamicComponentsStateProvider>
            </LocalizationProvider>
        </MainLayout>
    )
}